<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >
    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container
    v-else
    class="col-12 fill-height"
  >
    <v-tabs
      color="primary accent-4"
      v-if="!$route.params.action"
    >
      <v-tab>Packages by Benefit</v-tab>
      <v-tab>Bonuses In Packages</v-tab>
      <v-tab>Packages by Account</v-tab>
      <v-tab v-if="$store.state.auth.checkAccess({key: 'bonus_tools_approve', value: true})">Packages Approve</v-tab>
      <v-tab>Benefits</v-tab>
      <v-tab v-if="$store.state.auth.checkAccess({key: 'bonus_tools_tasks', value: true})">Tasks</v-tab>

      <v-tab-item>
        <packages-by-benefit />
      </v-tab-item>

      <v-tab-item>
        <bonuses-in-packages-by-benefit />
      </v-tab-item>

      <v-tab-item>
        <packages-by-account />
      </v-tab-item>

      <v-tab-item v-if="$store.state.auth.checkAccess({key: 'bonus_tools_approve', value: true})">
        <packages-approve />
      </v-tab-item>

      <v-tab-item>
        <benefits />
      </v-tab-item>

      <v-tab-item v-if="$store.state.auth.checkAccess({key: 'bonus_tools_tasks', value: true})">
        <tasks />
      </v-tab-item>

    </v-tabs>
    <main-view v-if="$route.params.action" :type="$route.params.action" />

  </v-container>
</template>

<style>
  .bonus-tools-dt.padding-footer .v-data-footer {
    padding-right: 40px;
  }
</style>

<script>
  import MainView from '@/components/bonus-tools/MainView'
  import Benefits from '@/components/bonus-tools/Benefits'
  import PackagesByBenefit from '@/components/bonus-tools/PackagesByBenefit'
  import PackagesByAccount from '@/components/bonus-tools/PackagesByAccount'
  import PackagesApprove from '@/components/bonus-tools/PackagesApprove'
  import BonusesInPackagesByBenefit from '@/components/bonus-tools/BonusesInPackagesByBenefit'
  import Tasks from '@/components/bonus-tools/Tasks.vue'

  export default {
    components: {
      Tasks,
      Benefits, PackagesByBenefit, PackagesByAccount, PackagesApprove, BonusesInPackagesByBenefit, MainView
    },

    data: () => ({}),

    computed: {},

    watch: {},

    methods: {}

  }
</script>


